'use client';

import dynamic from 'next/dynamic';
import { Context, FC, useContext } from 'react';

import { RequiredHeaderContextProps } from '@/types';

import * as S from './Header.styles';

const HeaderSearchInput = dynamic(
  () =>
    import('@/components/Header/HeaderSearchInput').then(
      mod => mod.HeaderSearchInput
    ),
  {
    ssr: false,
    loading: () => <S.SearchSkeleton data-testid="header-search-skeleton" />
  }
);

type Props = {
  context: Context<RequiredHeaderContextProps>;
  placeholder: string;
};

export const HeaderSearchSlot: FC<Props> = ({ context, placeholder }) => {
  const { visible } = useContext(context);

  if (typeof visible === 'boolean' && !visible) {
    return null;
  }

  return <HeaderSearchInput context={context} placeholder={placeholder} />;
};
